import { createFileRoute } from '@tanstack/react-router';
import { NotificationsPage } from '@/features/notifications/NotificationDetail';

/** Tutti gli avvisi ricevuti: il pannello della campanella si ferma agli ultimi cinquanta. */
export const Route = createFileRoute('/_app/notifications/')({ component: NotificationsPage });
